import _ from 'underscore';

const campaignIdToCampaignTypeMap = {};

export const getCampaignType = campaignId => campaignIdToCampaignTypeMap[campaignId] || '';

export const setCampaignType = (campaignId, campaignType) => {
  if (_.isNumber(campaignId) && _.isString(campaignType)) {
    campaignIdToCampaignTypeMap[campaignId] = campaignType;
  }
};

export const setCampaignTypes = (campaigns) => {
  if (_.isArray(campaigns)) {
    _.each(campaigns, campaign => setCampaignType(campaign.Id, campaign.CampaignType));
  }
};
